import React from 'react';
import PropTypes from 'prop-types';
import SelectNestedMenuDialog from './common/SelectNestedMenuDialog';
import { honorificNestedMenu } from '../../../../constants/SidebarValues';

const SelectHonorificDialog = (props) => (
  <SelectNestedMenuDialog
    {...props}
    title="役職を選択"
    nestedMenu={honorificNestedMenu}
    colCount={6}
  />
);

SelectHonorificDialog.propTypes = {
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  set: PropTypes.object,
  save: PropTypes.func.isRequired,
};

export default SelectHonorificDialog;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectHonorificDialog.jsx